import {
  MULTI_REQUEST_REGEX,
  MULTI_REQUEST_REPLACE_REGEX,
  REQUEST_ID_REGEX,
  REQUEST_LINK_REGEX,
  SINGLE_MULTI_REQUEST_REGEX,
} from './constants'
import type { IRequestLink } from './types'

export const parseRequestLink = (text: string): { parsedText: string; links: IRequestLink[] } => {
  MULTI_REQUEST_REGEX.lastIndex = 0

  const links: IRequestLink[] = []
  let parsedText = text

  // Обработка многоидентификаторов с оберткой
  parsedText = parsedText.replace(MULTI_REQUEST_REPLACE_REGEX, (match, prefix, mPrefix, multiId) => {
    const requestIdMatch = prefix.match(REQUEST_ID_REGEX)
    const linkId = requestIdMatch?.[1] || null
    const displayPrefix = prefix.replace(REQUEST_ID_REGEX, '')

    const requestIdTagMatch = match.match(REQUEST_ID_REGEX)

    let displayText = `${displayPrefix}${mPrefix}${multiId}`
    if (requestIdTagMatch) {
      displayText += ` ${requestIdTagMatch[1]}`
    }

    links.push({
      id: linkId,
      type: 'MULTIREQUEST',
      displayText,
    })

    return `{{LINK_${links.length - 1}}}`
  })

  parsedText = parsedText.replace(SINGLE_MULTI_REQUEST_REGEX, (_match, multiId, requestId) => {
    const displayText = `${multiId} ${requestId}`

    links.push({
      id: requestId,
      type: 'MULTIREQUEST',
      displayText,
    })

    return `{{LINK_${links.length - 1}}}`
  })

  parsedText = parsedText.replace(REQUEST_LINK_REGEX, (_, prefix, id) => {
    links.push({ id, type: 'SALEREQUEST', displayText: `${prefix}${id}` })

    return `{{LINK_${links.length - 1}}}`
  })

  return { parsedText, links }
}
